import { Button, Text } from '@chakra-ui/react';
import { t } from 'i18next';
import { InvalidSubscriptionIllustration } from '~components/ui/illustrations';
import { Link } from '~components/ui/Link';
import { Page } from '~components/ui/Page';
import { PageContent } from '~components/ui/PageContent';

export function InvalidSubscriptionPage() {
  return (
    <Page
      title="invalid subscription"
      pageName="invalid_subscription"
      analyticsDisableTracking={true}
    >
      <PageContent maxWidth="550px" textAlign="center">
        <InvalidSubscriptionIllustration />

        <Text fontWeight="semibold" fontSize="2xl">
          {t('invalidSubscriptionErr')}
        </Text>

        <Text marginTop="8" fontSize="md">
          {t('invalidSubscriptionErrMsg')}
          <Button margin={4} as={Link} variant="solid" size="sm" colorScheme="blue" to="../">
            {t('invalidSubscriptionErrMsg1')}
          </Button>
        </Text>
      </PageContent>
    </Page>
  );
}
